module.exports = __webpack_public_path__ + "static/media/icons.04a166ab.png";